const remarksButtonString = (id, title = '') => {
    return `<button type="button" class="btn btn-sm btn-outline-primary ml-2" data-action="open-remarks-modal" data-id="${id}" data-title="${title}" data-testid="remarks-button">Remarks</button>`;
}

const remarksViewButtonString = (id, title = '', content = '') => {
    // use popover instead of modal
    return `<i class="bi bi-gear" aria-hidden="true" tabindex="-1" data-toggle="popover" data-trigger="hover" title="${title}" data-content="${content}" data-id="${id}"></i>`;
}

export { remarksButtonString, remarksViewButtonString };